import { DolozkaZlucitelnostiApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import {
  DolozkaZlucitelnostiFormData,
} from '../../../model/sprievodnyDokument/dolozkaZlucitelnosti/DolozkaZlucitelnostiFormData';
import Uuid from '../../../model/Uuid';

const client = new DolozkaZlucitelnostiApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createDolozkaZlucitelnostiClient = async (
  uuid: Uuid,
  dolozkaZlucitelnosti: DolozkaZlucitelnostiFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const updateDolozkaZlucitelnostiClient = async (
  uuid: Uuid,
  dolozkaZlucitelnosti: DolozkaZlucitelnostiFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, headers);

  return {
    responseCode: status,
  };
};
